module.exports = __webpack_public_path__ + "img/parking_big.2397e066.webp";